import { elementTypeIsValid, type ElementTypes } from '@core/utils/type.ts'
import { b, type HTMLItemOptions, type SSGElement } from '@utils/build.ts'

interface CardBase {
  abstract: string
  buttonText?: string
  id?: string
  linkPath?: string
  linkText?: string
  title: string
}

export interface CardImg extends CardBase {
  src: string
}

export interface CardIcon extends CardBase {
  path: string
}

export type CardData = CardImg | CardIcon

export interface CardOptions {
  hover?: boolean
  type?: ElementTypes
}

export const generateCard = (document: Document, data: CardData, options: CardOptions): HTMLElement => {
  const cardOptions: HTMLItemOptions = { classes: [] }
  const divChildren: Array<SSGElement> = []

  if (data.id) {
    cardOptions.dataset = { id: data.id }
  }

  if (options.type && elementTypeIsValid(options.type)) {
    cardOptions.classes!.push(`card-${options.type}`)
  }

  if (options.hover) {
    cardOptions.classes!.push('card-hover')
  }

  if ('path' in data) {
    cardOptions.classes!.push('card-icon')
    divChildren.push(
      b('svg', document, {
        attrs: {
          viewBox: '0 0 24 24',
        },
        options: { isSVG: true },
        children: [b('path', document, { attrs: { d: data.path }, options: { isSVG: true } })],
      }),
    )
  } else {
    divChildren.push(b('img', document, { attrs: { src: data.src, alt: '' } }))
  }

  divChildren.push(
    b('section', document, {
      children: [b('h3', document, { text: data.title }), b('p', document, { text: data.abstract })],
    }),
  )

  if (data.buttonText) {
    if (data.linkPath && data.linkText) {
      divChildren.push(
        b('footer', document, {
          children: [
            b('a', document, {
              text: data.buttonText,
              attrs: { href: data.linkPath },
              arias: {
                label: data.linkText,
              },
            }),
          ],
        }),
      )
    } else {
      divChildren.push(b('footer', document, { children: [b('button', document, { text: data.buttonText })] }))
    }
  }

  return b('app-card', document, { ...cardOptions, children: [b('div', document, { children: divChildren })] })
}
